/* NMP reports (21/10/2026): smooth scroll to the product section + month shown with a 5-day lag. */
(function () {
  /* 22/10: the file can be included twice (article + footer section): run once */
  if (window.nmprReportJs) return; window.nmprReportJs = 1;
  var d = new Date(); d.setDate(d.getDate() - 5);
  var m = d.toLocaleString('en-US', { month: 'long', year: 'numeric' });
  function months() { document.querySelectorAll('[data-nmpr-month]').forEach(function (e) { e.textContent = m; }); }
  if (document.readyState !== 'loading') months(); else document.addEventListener('DOMContentLoaded', months);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#nmp-report"]');
    if (!a) return;
    var t = document.getElementById('nmp-report');
    if (!t) return;
    e.preventDefault();
    if (window.nmprGo) window.nmprGo(true); else t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#nmp-report');
  });
  /* 22/10 14:15: #nmp-report lands with the two columns (.nmpr-ps2__in) centred in the viewport; on mobile (< 900 px) or when they are taller
     than the screen, the section's top line lands at the top. The Dawn header hides while scrolling down, so it only counts when scrolling up. */
  function target(up) {
    var s = document.getElementById('nmp-report'); if (!s) return null;
    var c = s.querySelector('.nmpr-ps2__in') || s, vh = window.innerHeight, y0 = window.pageYOffset;
    var hd = document.querySelector('.section-header'), st = hd && /sticky/.test(getComputedStyle(hd).position);
    var hh = hd ? hd.offsetHeight : 0, sticky = document.querySelector('sticky-header');
    var off = st && (up || !sticky || sticky.getAttribute('data-sticky-type') === 'always') ? hh : 0;
    var sR = s.getBoundingClientRect(), sTop = sR.top + y0, sBot = sR.bottom + y0, cR = c.getBoundingClientRect(), cTop = cR.top + y0, ch = cR.height;
    /* 22/10 14:35: on desktop the section is at least one screen high (CSS min-height 100svh): centre the columns in the screen,
       then clamp so the section covers the whole screen (no blog above or below, even if the header slides away). */
    var y = sTop - off;
    if (window.innerWidth >= 900 && ch <= vh - off - 16) {
      y = cTop - Math.max(off, (vh - ch) / 2);
      if (sBot - sTop >= vh) y = Math.min(Math.max(y, sTop), sBot - vh);
      /* product page: the section sits right under the header at the top of the page and fills the rest of the screen */
      if (sTop <= hh + 2 && sBot >= vh - 2) y = 0;
    }
    s.style.scrollMarginTop = Math.round(sTop - y) + 'px';
    return Math.max(0, Math.round(y));
  }
  window.nmprGo = function (smooth) {
    var y = target(false); if (y == null) return;
    if (y < window.pageYOffset) y = target(true);
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
    /* re-aim once the scroll settles (late layout shifts) */
    clearTimeout(window.nmprGoT);
    window.nmprGoT = setTimeout(function () { var z = target(y < window.pageYOffset); if (z != null && Math.abs(z - window.pageYOffset) > 3) window.scrollTo({ top: z, behavior: 'auto' }); }, smooth ? 1100 : 250);
  };
  /* sticky header height, used by the CSS on product pages (section right under the header) */
  function setHH() { var hd = document.querySelector('.section-header'); if (hd) document.documentElement.style.setProperty('--nmpr-hh', hd.offsetHeight + 'px'); }
  function aim() { setHH(); target(false); }
  window.addEventListener('resize', aim);
  window.addEventListener('load', function () {
    aim();
    if (location.hash === '#nmp-report') { var y = target(false); if (y != null && Math.abs(y - window.pageYOffset) < window.innerHeight * 1.5) window.nmprGo(false); }
  });
  if (document.readyState !== 'loading') aim(); else document.addEventListener('DOMContentLoaded', aim);
  /* hide the contents sidebar once the reader reaches "Our methodology" (or the end of the article) */
  function tocGone() {
    var mark = null;
    document.querySelectorAll('.nmp-art .container-summary').forEach(function (c) { if (!mark && /methodology/i.test(c.textContent.slice(0, 80))) mark = c; });
    mark = mark || document.querySelector('.nmp-end') || document.getElementById('nmp-report');
    if (!mark) return;
    var on = false;
    function chk() {
      var g = mark.getBoundingClientRect().top < window.innerHeight * 0.6;
      if (g !== on) { on = g; document.documentElement.classList.toggle('nmp-toc-gone', g); }
    }
    window.addEventListener('scroll', chk, { passive: true }); window.addEventListener('resize', chk); chk();
  }
  if (document.readyState !== 'loading') tocGone(); else document.addEventListener('DOMContentLoaded', tocGone);
})();

/* 22/10/2026 v2 product section: desktop cover slider (cover + thumbnails = height of the text column), arrows on hover, thumbnails; mobile carousel with dots. */
(function () {
  function init(sec) {
    if (sec.getAttribute('data-nmpr-init')) return; sec.setAttribute('data-nmpr-init', '1');
    var head = sec.querySelector('.nmpr-ps2__head'), body = sec.querySelector('.nmpr-ps2__body'), below = sec.querySelector('.nmpr-ps2__below');
    var sl = sec.querySelector('.nmpr-ps2__sl'), tr = sec.querySelector('.nmpr-ps2__track');
    var L = sec.querySelector('.nmpr-ps2__ar--l'), R = sec.querySelector('.nmpr-ps2__ar--r');
    var th = [].slice.call(sec.querySelectorAll('.nmpr-ps2__t')), n = tr.children.length;
    sec.querySelectorAll('.nmpr-ps2__dots').forEach(function (d) { if (d.children.length) return; for (var i = 0; i < n; i++) { var e = document.createElement('i'); if (!i) e.className = 'on'; d.appendChild(e); } });
    var mq = window.matchMedia('(min-width: 900px)');
    function fit() {
      if (!mq.matches) { sl.style.width = ''; sl.style.height = ''; return; }
      var total = head.offsetHeight + body.offsetHeight, w = 340, h;
      for (var k = 0; k < 3; k++) { sl.style.width = w + 'px'; h = total - below.offsetHeight - 12; w = Math.round(Math.max(260, h) * 1450 / 2051); }
      h = Math.max(260 * 2051 / 1450, total - below.offsetHeight - 12);
      sl.style.height = Math.round(h) + 'px'; sl.style.width = Math.round(h * 1450 / 2051) + 'px';
      halo();
    }
    /* 22/10 14:15: the right-column halo ends just under the bullets */
    var inn = sec.querySelector('.nmpr-ps2__in'), toc = sec.querySelector('.nmpr-ps2__toc');
    function halo() { if (inn && toc) inn.style.setProperty('--nmpr2-hb', Math.round(inn.getBoundingClientRect().bottom - toc.getBoundingClientRect().bottom - 18) + 'px'); }
    function step() { return tr.children[0].offsetWidth + (mq.matches ? 0 : 12); }
    function idx() {
      var i = Math.round(tr.scrollLeft / step());
      if (!mq.matches && tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4) i = n - 1;
      return Math.max(0, Math.min(n - 1, i));
    }
    function upd() {
      var i = idx();
      sec.querySelectorAll('.nmpr-ps2__dots').forEach(function (d) { [].forEach.call(d.children, function (e, j) { e.classList.toggle('on', j === i); }); });
      th.forEach(function (t, j) { t.classList.toggle('on', j === i); });
      if (L) L.disabled = i === 0; if (R) R.disabled = i === n - 1;
    }
    function go(i) { i = Math.max(0, Math.min(n - 1, i)); tr.scrollTo({ left: i * step() }); }
    if (L) L.addEventListener('click', function () { go(idx() - 1); });
    if (R) R.addEventListener('click', function () { go(idx() + 1); });
    th.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    tr.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); } });
    var raf; tr.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    fit(); upd();
    if (window.ResizeObserver) { var ro = new ResizeObserver(fit); ro.observe(head); ro.observe(body); }
    window.addEventListener('resize', function () { fit(); upd(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }
  function all() { document.querySelectorAll('.nmpr-ps2').forEach(init); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
})();